import { create } from 'zustand';

import type { SharePlanUnionType } from '../../../../types/pool-plans.types';
import type { TemplateFieldContext } from '../types/template-field-context.types';

import { VariableMappingType } from '../enums/mapping-editor.const';

export { TemplateFieldType, VariableMappingType } from '../enums/mapping-editor.const';

type MappingEditorStoreState = {
  clearVariableMappings: () => void;
  selectedEquityPlan: null | SharePlanUnionType;
  setSelectedEquityPlan: (plan: null | SharePlanUnionType) => void;
  setTemplateContext: (context: null | TemplateFieldContext) => void;
  setVariableMapping: (varName: string, value: string, type: VariableMappingType) => void;
  setVariableMappings: (
    mappings: Record<string, string>,
    types?: Record<string, VariableMappingType>,
  ) => void;
  templateContext: null | TemplateFieldContext;
  variableMappings: Record<string, string>;
  variableMappingTypes: Record<string, VariableMappingType>;
};

const INITIAL_STATE: Pick<
  MappingEditorStoreState,
  'selectedEquityPlan' | 'templateContext' | 'variableMappings' | 'variableMappingTypes'
> = {
  selectedEquityPlan: null,
  templateContext: null,
  variableMappings: {},
  variableMappingTypes: {},
};

export const MappingEditorStore = create<MappingEditorStoreState>()((set) => ({
  ...INITIAL_STATE,

  clearVariableMappings: () => set({ variableMappings: {}, variableMappingTypes: {} }),

  setSelectedEquityPlan: (plan) => set({ selectedEquityPlan: plan }),

  setTemplateContext: (context) => set({ templateContext: context }),

  setVariableMapping: (varName, value, type) =>
    set((state) => ({
      variableMappings: { ...state.variableMappings, [varName]: value },
      variableMappingTypes: { ...state.variableMappingTypes, [varName]: type },
    })),

  setVariableMappings: (mappings, types) =>
    set({
      variableMappings: { ...mappings },
      variableMappingTypes: Object.fromEntries(
        Object.keys(mappings).map((k) => [k, types?.[k] ?? VariableMappingType.SYSTEM]),
      ) as Record<string, VariableMappingType>,
    }),
}));
